import { cx } from '@/utils/strings'

export default function ChatBubbleStem({ reverse = false }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 23" className={cx(reverse && 'scale-x-[-1]')}>
      <path
        fill="currentColor"
        d="M18 22.5C8.977 15.377 9.191.536 9.191.536l-9 14.84C5.89 20.127 14.438 22.105 18 22.5Z"
      />
    </svg>
  )
}
